import React from 'react'
import SliderTopResult from '../../component/slidercomponent/SliderTopResult'

const HomeTopResult = () => {
    return (
        <>

        
<section className="team-section section-padding fix">
        <div className="container">
          <div className="section-title-area">
            <div className="section-title">
              <span className="sub-title wow fadeInUp">Our Instructors</span>
              <h2 className="wow fadeInUp" data-wow-delay=".3s">
                Meet Our Expert <br /> Instructor
              </h2>
            </div>
            <div className="array-buttons wow fadeInUp" data-wow-delay=".5s">
              <button className="array-prev"><i className="fas fa-arrow-left" /></button>
              <button className="array-next"><i className="fas fa-arrow-right" /></button>
            </div>
          </div>
          <div className="swiper team-slider">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <div className="team-card-item-2">
                  <div className="team-image">
                    <img src="assets/img/team/team-5.jpg" alt="img" />
                    <div className="team-content">
                      <h4>
                        <a href="team-details.html">
                          Brooklyn Simmons
                        </a>
                      </h4>
                      <p>Instructors</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="team-card-item-2">
                  <div className="team-image">
                    <img src="assets/img/team/team-6.jpg" alt="img" />
                    <div className="team-content">
                      <h4>
                        <a href="team-details.html">
                          Brooklyn Simmons
                        </a>
                      </h4>
                      <p>Instructors</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="team-card-item-2">
                  <div className="team-image">
                    <img src="assets/img/team/team-7.jpg" alt="img" />
                    <div className="team-content">
                      <h4>
                        <a href="team-details.html">
                          Brooklyn Simmons
                        </a>
                      </h4>
                      <p>Instructors</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-slide">
                <div className="team-card-item-2">
                  <div className="team-image">
                    <img src="assets/img/team/team-8.jpg" alt="img" />
                    <div className="team-content">
                      <h4>
                        <a href="team-details.html">
                          Brooklyn Simmons
                        </a>
                      </h4>
                      <p>Instructors</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


        </>
    )
}

export default HomeTopResult